var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwinklestar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 37.9 36.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #005d66;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m20.6,11.76c2.25,2.95,4.9,5.59,7.86,7.83-2.98,2.25-5.65,4.91-7.91,7.88-2.26-2.94-4.92-5.58-7.88-7.82,2.99-2.26,5.66-4.91,7.93-7.89m.01-9.56l-.68,1.3c-3.63,7.01-9.46,12.62-16.61,15.98l4.08,2.6c4.65,2.97,8.55,6.97,11.4,11.69l1.8,2.98,1.19-2.11c3.04-5.41,7.43-9.94,12.74-13.14l3.36-2.03-.1-.05c-7.4-3.49-13.38-9.4-16.95-16.76l-.23-.47h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m7.02,6.88c.06.06.13.13.19.19-.07.07-.15.15-.22.22-.06-.06-.13-.13-.19-.19.07-.07.15-.15.22-.22m0-6.88l-.27.53C5.28,3.38,2.9,5.66,0,7.03l1.66,1.06c1.89,1.21,3.48,2.84,4.64,4.76l.73,1.21.48-.86c1.24-2.2,3.02-4.04,5.18-5.35l1.37-.82-.04-.02c-3.01-1.42-5.44-3.82-6.89-6.82l-.09-.19h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwinklestar);
export default __webpack_public_path__ + "static/media/twinklestar.2a363bff1cd5c64fb6d38d07cb4cfc6d.svg";
export { ForwardRef as ReactComponent };